import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { Flame } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="App flex flex-col min-h-screen bg-background">
      <Seo title={t("errors.notFoundTitle")} path="/404" noindex />
      <Navbar />
      <main className="flex-1 grid place-items-center px-6 py-24 text-center" data-testid="not-found">
        <div>
          <span className="grid place-items-center w-16 h-16 rounded-full bg-primary/15 text-primary mx-auto mb-6">
            <Flame size={30} />
          </span>
          <p className="font-heading text-6xl font-black text-primary">404</p>
          <h1 className="font-heading text-2xl font-bold mt-3">{t("errors.notFoundTitle")}</h1>
          <p className="text-slate-400 mt-2 max-w-md mx-auto text-sm">{t("errors.notFoundBody")}</p>
          <Button data-testid="notfound-home" onClick={() => navigate("/")} className="mt-6 bg-primary hover:bg-primary/90 text-white rounded-full px-6">
            {t("errors.goHome")}
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
